export { default, getServerSideProps } from "pages/cbd-stores/[[...location]]";
